module.exports = __webpack_public_path__ + "static/media/online.324ebf46.svg";